module.exports = __webpack_public_path__ + "media/images/hero-pc-4bb6d6d72249d0f58d528321b6ca58cb.jpg";